<template>
  <AppLayout>
    <div class="payments-layout">
      <v-flex sm12>
        <v-toolbar color="white" class="elevation-0">
          <v-toolbar-side-icon>
            <v-icon large color="primary">attach_money</v-icon>
          </v-toolbar-side-icon>
          <v-toolbar-title class="title">{{ sectionTitle }}</v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <slot />
      </v-flex>
    </div>
  </AppLayout>
</template>
<script>
import AppLayout from '@/views/AppLayout'

export default {
  name: 'Payments',
  components: { AppLayout },
  data() {
    return {
      sectionTitle: ''
    }
  },
  watch: {
    $route(to, from) {
      this.sectionTitle = to.meta.menuTitle + ' Payments'
    }
  },
  mounted() {
    this.sectionTitle = this.$router.currentRoute.meta.menuTitle + ' Payments'
  },
  methods: {
    processPayments() {
      this.$root.$emit('xp-process-payments')
    },
    generateBankFile() {
      this.$root.$emit('xp-generate-bank-file')
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~vuetify/src/stylus/settings/_colors';

.payments-layout {
  max-width: 1250px;
  margin: 0 auto;
}

.payments-layout__menu {
  border-bottom: 1px solid $grey.lighten-2;
}

.v-toolbar__title {
  margin-left: 0;
  font-size: 24px !important;
  line-height: 1.5 !important;
}
</style>
